import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { i18nReady, loadExtra } from './i18n';
import './theme.css';
import './styles.css';
import { App } from './App';
import { VersionTag } from './components/VersionTag';
import { startNative } from './native';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

// Wait for the person's language (only non-English languages are fetched) so nothing renders in the wrong one.
void i18nReady.then(() =>
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        {/* the build stamp, bottom-left on every screen (sign-in, pending, the app, the Platform console) */}
        <VersionTag />
      </QueryClientProvider>
    </React.StrictMode>,
  ),
);

// §23 M12.6 then, when the browser is idle, the rest of the English strings (lazy pages also fetch them first).
const idle = window.requestIdleCallback ?? ((fn: () => void) => setTimeout(fn, 1500));
void i18nReady.then(() => idle(() => void loadExtra()));

// #145 M21.2 inside the mobile app: back button, outside links, status bar (a no-op in a browser)
startNative();

// #145 M21.1 installable, and starts offline (static files only; never any organisation data — see pwa/sw.js)
if ('serviceWorker' in navigator && import.meta.env.PROD)
  window.addEventListener(
    'load',
    () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined),
  );
